import { AnyAction } from 'redux'

const INITIAL_STATE: State.DesignPersonalizationState = {
  designPersonalizationContext: undefined,
  designPersonalizationContextId: undefined,
  dpcsLoading: false,
}

export const DESIGN_PERSONALIZATION_CONTEXT_UPDATE = 'DESIGN_PERSONALIZATION_CONTEXT_UPDATE'
export const DESIGN_PERSONALIZATION_CONTEXT_ID_UPDATE = 'DESIGN_PERSONALIZATION_CONTEXT_ID_UPDATE'

export const DPCS_LOADING_UPDATE = 'DPCS_LOADING_UPDATE'

export function reducer(state: State.DesignPersonalizationState = INITIAL_STATE, action: AnyAction): State.DesignPersonalizationState {
  switch (action.type) {
    case DESIGN_PERSONALIZATION_CONTEXT_UPDATE: {
      return {
        ...state,
        designPersonalizationContext: action.payload.dpc,
      }
    }
    case DESIGN_PERSONALIZATION_CONTEXT_ID_UPDATE: {
      return {
        ...state,
        designPersonalizationContextId: action.payload.id,
      }
    }
    case DPCS_LOADING_UPDATE: {
      return {
        ...state,
        dpcsLoading: action.payload.dpcsLoading,
      }
    }
    default:
      return state
  }
}
